
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { BFormInput, BModal } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ISolCustomerEmployee } from "@/services";
import { i18n } from "@/i18n";

@Component({
  name: "document-validation-modal",
  components: {
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class DocumentValidationModal extends Vue {
  @Prop({ required: true }) public employee!: ISolCustomerEmployee;
  validationDocumentValueArray: string[] = [];

  random1 = 0;
  random2 = 1;

  $refs!: {
    documentValidationModal: InstanceType<typeof PModal>;
    input2?: InstanceType<typeof BFormInput>[];
  };

  get validationDocumentValue(): string {
    return this.employee.validationDocumentValue?.trim() || "";
  }

  showModal(): void {
    this.validationDocumentValueArray = Array.from(this.validationDocumentValue);

    if (this.validationDocumentValueArray.length > 2) {
      this.random1 = this.generateRandom();
      this.random2 = this.generateRandom(this.random1);

      if (this.random2 < this.random1) {
        const aux = this.random1;
        this.random1 = this.random2;
        this.random2 = aux;
      }

      this.validationDocumentValueArray[this.random1] = "";
      this.validationDocumentValueArray[this.random2] = "";
    } else {
      this.validationDocumentValueArray = this.validationDocumentValueArray.map(() => "");
    }

    const pModal = this.$refs.documentValidationModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.show();
  }

  hideModal(): void {
    this.random1 = 0;
    this.random2 = 1;
    this.validationDocumentValueArray = [];
    const pModal = this.$refs.documentValidationModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.hide();
  }

  onDigitInput(index: number): void {
    if (index === this.random1) {
      this.$refs.input2?.[0]?.focus();
    }
  }

  generateRandom(distinctOf?: number): number {
    const length = this.validationDocumentValueArray.length;

    if (length <= 1) {
      return 0;
    }

    const random = Math.floor(Math.random() * length);
    if (random !== distinctOf) {
      return random;
    }

    return (random + 1) % length;
  }

  async onSubmit(): Promise<void> {
    if (this.validationDocumentValueArray.join("") === this.validationDocumentValue) {
      this.$emit("success", this.employee);
      this.hideModal();
    } else {
      Vue.swal({
        title: i18n.t("label.documentValidation.invalid").toString(),
        icon: "error",
      });
    }
  }
}
